import { Badge } from "@chakra-ui/react";
import type { EnumValue } from "models/types/api-listing";
import { useIsAgencyFeaturePreferenceEnabled } from "hooks/use-is-agency-feature-preference-enabled";

export const colorMap = {
  cold: "badgeBlue",
  warm: "badgeOrange",
  hot: "badgeRed",
  unknown: "gray",
} as const;

type InterestLevelBadgeProps = {
  interestLevel: EnumValue;
};
export function InterestLevelBadge({ interestLevel }: InterestLevelBadgeProps) {
  const isAgencyFeaturePreferenceEnabled =
    useIsAgencyFeaturePreferenceEnabled();

  if (
    !isAgencyFeaturePreferenceEnabled(
      "vendor_portal.functionality.interest_level.show_interest_level_data",
    )
  ) {
    return null;
  }

  return (
    <Badge colorScheme={colorMap[interestLevel.id as keyof typeof colorMap]}>
      {interestLevel.label}
    </Badge>
  );
}
